import { FormattedMessage } from 'react-intl';

import { badgeIntlId, getBadgeStyle, normalizeBadge } from '@/pages/drama-review/utils';

import styles from './badge-display.module.less';

type BadgeDisplayProps = {
    value?: string | null;
};

const BadgeDisplay: React.FC<BadgeDisplayProps> = ({ value }) => {
    const normalizedValue = normalizeBadge(value);
    const badgeStyle = getBadgeStyle(normalizedValue);

    if (!normalizedValue || !badgeStyle) {
        return <span className={styles.empty}>-</span>;
    }

    return (
        <span className={`${styles.badge} ${styles[badgeStyle.className]}`}>
            <img className={styles.icon} src={badgeStyle.icon} alt="" />
            <FormattedMessage id={badgeIntlId(normalizedValue)} />
        </span>
    );
};

export default BadgeDisplay;
